<template>
  <div>
    <div class="d-flex justify-content-end">
      <div class="py-2">
        <span>
          {{ paginationText }}
        </span>
      </div>
      <div v-if="pagination.items > perPage" class="pl-3">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :class="paginationClass"
          :total-rows="pagination.items"
        ></b-pagination>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="pt-2">
        <span class="mr-2">
          {{ productsPerPage }}
        </span>
      </div>
      <div>
        <b-select v-model="perPage">
          <option v-for="value in paginationOptions" :key="value" :value="value" v-text="value"></option>
        </b-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    paginationOptions: {
      type: Array,
      required: true,
    },
    paginationText: {
      type: String,
      required: true,
    },
    productsPerPage: {
      type: String,
      required: true,
    },
    paginationClass: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    perPage: {
      get() {
        return this.pagination.perPage
      },
      set(newValue) {
        this.$emit('on-change-per-page', newValue)
      },
    },
    currentPage: {
      get() {
        return this.pagination.currentPage
      },
      set(newValue) {
        this.$emit('on-change-current-page', newValue)
      },
    },
  },
}
</script>
